import Home from './view/home/route';
import Notice from './view/notice/route';
import Board from './view/board/route';
import Batcha from './view/batcha/route';
import Branch from './view/branch/route';
import Driver from './view/driver/route';
import Manager from './view/manager/route';
import PlaceManager from './view/placemanager/route';
import Stats from './view/stats/route';
import Report from './view/report/route';
import Basic from './view/basic/route';
import Admin from './view/admin/route';

const route = {};
route['home'] = Home;
route['board'] = Board;
route['notice'] = Notice;
route['batcha'] = Batcha;
route['branch'] = Branch;
route['driver'] = Driver;
route['manager'] = Manager;
route['placemanager'] = PlaceManager;
route['stats'] = Stats;
route['report'] = Report;
route['basic'] = Basic;
route['admin'] = Admin;

export default route;
